import { LastMessageText } from '@halo/ui-chat-react';
import type { Msg, Session } from '@halo/chat-sdk-react';
import { Box } from '@chakra-ui/react';
import { Emoji } from '@/components/Emoji';
import { MsgForwardIcon } from '../../msg-parts';
import { MsgTransferPreviewContent } from './msg-transfer-preview-content';

export interface MsgTransferPreviewProps {
  session: Session;
  message: Msg;
}

export const MsgTransferPreview = memo(function MsgTransferPreview({
  session,
  message,
}: MsgTransferPreviewProps) {
  return (
    <LastMessageText>
      <Emoji.MessagePrefix reactions={message.emoji_reaction} />
      <MsgForwardIcon message={message} />
      <Box flex="1" minW="0" truncate>
        <MsgTransferPreviewContent session={session} message={message} />
      </Box>
    </LastMessageText>
  );
});
